app.ClonableUserList = app.AbstractCollection.extend({
  model: app.ClonableUser,

  initialize(models, options) {
    app.AbstractCollection.prototype.initialize.apply(this, arguments);

    this._sourceOrgId = options.sourceOrgId;
    if (!this._sourceOrgId) {
      throw new Error('sourceOrgId is required to initialize ClonableUserList');
    }
  },

  url() {
    return `/api/orgs/${this._sourceOrgId}/clonable-users`;
  },
});
